import { NextPage } from 'next'
import Screen404 from '../screens/404'

export const Page404: NextPage = () => {

    return (
        <>
            <Screen404 />
        </>
    )
}